import {httpsCallable} from "firebase/functions";
import {functions} from "../firebaseConfig";
import {doc, getDocFromServer} from "firebase/firestore";
import {db} from "../firebaseConfig";
// Authenticated workspace-only boundary. Never import into public routes.
export async function getOrganizationWorkspace(organizationId, purpose = "workspace") {
  const {data} = await httpsCallable(functions, "getOrganizationWorkspaceContext")({organizationId, purpose});
  if (data?.schemaVersion !== 1 || data.organizationId !== organizationId || data.purpose !== purpose || data.data?.id !== organizationId) throw new Error("Organization context is unavailable. Please retry.");
  return data.data;
}

export async function getWebsiteEditorContext(organizationId) {
  // Only actual administrators may receive the internal record, as enforced
  // by Rules. A scoped website editor gets presentation fields from the server.
  // This module is private-workspace-only, never a public reader fallback.
  try {
    const snap = await getDocFromServer(doc(db, "organizations", organizationId));
    if (!snap.exists()) throw new Error("Organization not found.");
    return {...snap.data(), id: organizationId};
  } catch (error) {
    if (!String(error.code || "").endsWith("permission-denied")) throw error;
    return getOrganizationWorkspace(organizationId, "websiteEditor");
  }
}

export async function loadMinistryOptions(organizationId) {
  if (!organizationId) return [];
  return (await getOrganizationWorkspace(organizationId, "ministryOptions")).ministryOptions || [];
}
